module.exports = __webpack_public_path__ + "up-arrow-dropdown.6d300ef5a36a7e61bb5c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin-icons/up-arrow-dropdown.svg
// module id = 855
// module chunks = 6